class GiftCardRecipient extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.enableInput = this.querySelector("[data-enable]");
    this.enableInput.addEventListener("change", () => {
      this.toggleAttribute("send-as-gift", this.enableInput.checked);
      this.querySelectorAll("[data-required]").forEach((requiredInput) => {
        requiredInput.required = this.enableInput.checked;
      });
      if (this.enableInput.checked) {
        this.open();
      } else {
        this.close();
      }
    });
  }

  open() {
    this.removeEventListener("transitionend", this.handleTransitionEnd);
    if (this.content) {
      this.content.style.display = "flex";
      this.content.style.height = 0;
      this.content.style.opacity = 0;
      this.content.style.overflow = "hidden";

      this.handleTransitionEnd = () => {
        this.removeEventListener("transitionend", this.handleTransitionEnd);
        this.content.style.height = null;
        this.content.style.overflow = null;
      };

      this.addEventListener("transitionend", this.handleTransitionEnd);

      window.requestAnimationFrame(() => {
        this.content.style.height = `${this.content.scrollHeight}px`;
        this.content.style.opacity = 1;
      });
    }
  }

  close() {
    if (this.content) {
      this.removeEventListener("transitionend", this.handleTransitionEnd);

      this.content.style.height = `${this.content.scrollHeight}px`;
      this.content.style.overflow = "hidden";

      window.requestAnimationFrame(() => {
        this.handleTransitionEnd = () => {
          this.removeEventListener("transitionend", this.handleTransitionEnd);
          this.content.style.display = null;
          this.content.style.overflow = null;
        };

        this.addEventListener("transitionend", this.handleTransitionEnd);

        this.content.style.height = 0;
        this.content.style.opacity = 0;
      });
    }
  }

  get content() {
    return this.querySelector("[data-content]");
  }
}

if (!customElements.get("gift-card-recipient")) {
  customElements.define("gift-card-recipient", GiftCardRecipient);
}
